// eslint-disable-next-line no-restricted-imports
import moment from 'moment';
import type { VoidFunctionComponent } from 'react';

import Flex from '../../../../generic/Flex';
import Icon, { icons } from '../../../../generic/Icon';
import Link from '../../../../generic/Link/Link';
import IssueItemBadge from '../IssueItemBadge';
import WithSeparator from '../WithSeparator';
import type { AnyTicket } from '../../../../../../shared/issuesV2';

import styles from './IssueTicketBadge.module.less';

type IssueTicketBadgeProps = {
  tickets: AnyTicket[];
};

/**
 * Represents the badge which displays + links to the
 * Jira ticket which is linked to this issue, if it exists.
 */
const IssueTicketBadge: VoidFunctionComponent<IssueTicketBadgeProps> = ({ tickets }) => {
  let linkOrCount;
  if (tickets.length > 1) {
    linkOrCount = <span>Ticketed ({tickets.length})</span>;
  } else if (tickets[0]) {
    const ticket = tickets[0];
    const createdDate = moment(ticket.createdAt);

    let label;
    if (ticket.type === 'jira') {
      label = <span>#{ticket.id} created {createdDate.fromNow()}</span>;
    } else if (ticket.type === 'custom') {
      label = <span>Ticket linked {createdDate.fromNow()}</span>;
    }

    // only link to the ticket in Jira if a URL is present
    if (ticket.url) {
      linkOrCount = (
        <Flex gap="5px">
          <Link to={ticket.url} openInNewTab>
            {label}
            &nbsp;
            <Icon icon={icons.externalLink} />
          </Link>
        </Flex>
      );
    } else {
      linkOrCount = label;
    }
  }

  return (
    <WithSeparator>
      <IssueItemBadge>
        <span className={styles.ticketIcon}>
          <Icon icon={icons.ticket} />
        </span>
        {linkOrCount}
      </IssueItemBadge>
    </WithSeparator>
  );
};

export default IssueTicketBadge;
